import { filter, mergeMap, of } from 'rxjs'
import { catchError, retryWhen } from 'rxjs/operators'
import { authenticationExpiredOr } from '../../../../Framework/Epic/AuthenticationExpired.js'
import { serverIsNotAvailable } from '../../../../Framework/Epic/ServerNotAvailable.js'
import type { Epic } from '../../../index.js'
import { orderSlice } from '../../../Slice/Order/OrderSlice.js'

export const UpdatePoolItemEpic: Epic = (action$, state$, { [orderSlice.name]: order, OrderRepository }) =>
  action$.pipe(
    filter(order.updatePoolItemRequest.match),
    mergeMap((action) =>
      OrderRepository.updatePoolContent(action.payload.orderId, action.payload.poolId, [action.payload.item]).pipe(
        mergeMap((response) =>
          of(order.updateContentSuccess({ orderId: action.payload.orderId, poolId: action.payload.poolId, content: response }))
        ),
        retryWhen(serverIsNotAvailable()),
        catchError((error) =>
          authenticationExpiredOr({
            error,
            failedRequest: action.type,
            failureAction: of(order.updateContentFailure({ error }))
          })
        )
      )
    )
  )
